"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var next_intl_1 = require("next-intl");
var apps_shared_1 = require("@l2p/apps-shared");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Languages = function (_a) {
    var languages = _a.languages;
    var currentLang = (0, next_intl_1.useLocale)();
    var t = (0, next_intl_1.useTranslations)('languages');
    var getPageWithNewLang = (0, apps_shared_1.usePageWithNewLang)();
    return (react_1.default.createElement("div", null, languages.map(function (lang) {
        return (react_1.default.createElement("div", { key: "lang".concat(lang.key) },
            react_1.default.createElement("a", { href: getPageWithNewLang(lang.key), key: lang.key, className: styles_module_scss_1.default.currentLangItem },
                react_1.default.createElement("span", { className: "".concat(styles_module_scss_1.default.check, " ").concat(currentLang === lang.key ? styles_module_scss_1.default.checkActive : '') }),
                react_1.default.createElement("span", { className: styles_module_scss_1.default.langText },
                    " ",
                    t(lang.key)))));
    })));
};
exports.default = Languages;
